import React from "react";
import ReactApexChart from "react-apexcharts";
import SaveBtn from "../../../common/SaveBtn";
import colors from "../../../../helpers/colors";
import useCERTotalCount from "./useCERTotalCount";

const CERTotalCount = ({
  url,
  year,
  displayTotal,
  showLine = true,
  showPie = true,
  otherPostParams = {},
}) => {
  const { isLoading, chartState, getDatas, hasDatas, total } = useCERTotalCount(
    url,
    year,
    otherPostParams
  );

  return (
    <div className="row">
      <div className="col-12 d-flex align-items-center justify-content-end">
        <SaveBtn
          type={hasDatas ? "btn-default d-center" : "btn-primary d-center"}
          color={hasDatas ? colors.primary : colors.default}
          margin="m-0 get-stat-btn"
          save={getDatas}
          isSaving={isLoading}
          text={
            hasDatas ? (
              <>
                <i className="fa fa-sync mr-2" />
                Actualiser les données
              </>
            ) : (
              <>
                <i className="fa fa-cloud-download-alt mr-2" />
                Charger les données
              </>
            )
          }
        />
      </div>
      {!isLoading && hasDatas ? (
        <>
          <div className="col-12">
            {showLine && (
              <ReactApexChart
                options={chartState.line.options}
                series={chartState.line.series}
                type="bar"
                height={350}
              />
            )}
          </div>

          {displayTotal ? (
            <div className="col-12 text-center font-weight-bold">TOTAL : {total}</div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default CERTotalCount;
